var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonScissors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -1172.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Scissors",
    transform: "translate(1206.000000, 1172.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.774,25.7213318 C3.418,25.7213318 2.318,24.6399966 2.318,23.3070052 C2.318,21.9730307 3.418,20.8916955 4.774,20.8916955 C6.131,20.8916955 7.231,21.9730307 7.231,23.3070052 C7.231,24.6399966 6.131,25.7213318 4.774,25.7213318 L4.774,25.7213318 Z M4.774,12.1092875 C3.418,12.1092875 2.318,11.0279523 2.318,9.69397786 C2.318,8.36098645 3.418,7.27965124 4.774,7.27965124 C6.131,7.27965124 7.231,8.36098645 7.231,9.69397786 C7.231,11.0279523 6.131,12.1092875 4.774,12.1092875 L4.774,12.1092875 Z M32,5.96926956 L27.319,5.96926956 C25.965,5.96926956 24.662,6.36936359 23.57,7.1125358 L14.044,13.2191307 L9.549,9.69397786 C9.549,7.10172244 7.412,5 4.774,5 C2.137,5 0,7.10172244 0,9.69397786 C0,12.2862333 2.137,14.3879557 4.774,14.3879557 C5.688,14.3879557 6.553,14.1539941 7.258,13.6860709 C7.603,13.4570244 7.977,13.1650639 8.227,12.9153738 C9.452,13.1571996 11.393,14.7231696 11.393,16.5004915 C11.393,18.2778134 9.452,19.8428004 8.227,20.0846262 C7.977,19.8349361 7.603,19.5439586 7.258,19.3149122 C6.553,18.8469889 5.688,18.6120443 4.774,18.6120443 C2.137,18.6120443 0,20.7147498 0,23.3070052 C0,25.8982776 2.137,28 4.774,28 C7.412,28 9.549,25.8982776 9.549,23.3070052 L14.046,19.7356499 L23.548,25.8737018 C24.661,26.6316194 25.964,27.0326965 27.319,27.0326965 L32,27.0326965 L18.31,16.5004915 L32,5.96926956 Z",
    id: 212
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonScissors);
export default __webpack_public_path__ + "static/media/common-scissors.672d8d37.svg";
export { ForwardRef as ReactComponent };